import { FC, MutableRefObject } from 'react';
import { Toast } from 'primereact/toast';
import ToastExportXLSorCSV from '../../../ExportCSV/ToastExportXLSorCSV';
import ToastSuccessful from '../../../ExportCSV/ToastSuccessful';

interface Props {
  downloadToastRef: MutableRefObject<Toast | null>;
  successToastRef: MutableRefObject<Toast | null>;
  progress: number;
  onClear: () => void;
}

const ExportToastHost: FC<Props> = ({ downloadToastRef, successToastRef, progress, onClear }) => {
  return (
    <>
      <ToastExportXLSorCSV downloadToastRef={downloadToastRef} clear={onClear} progressValueToast={progress} />
      <ToastSuccessful successfullToastRef={successToastRef} />
    </>
  );
};

export default ExportToastHost;
